import { Injectable, signal } from '@angular/core';
import { GameMode } from '../models/requests/game-mode.enum';
import { Theme } from '../models/responses/theme';

/**
 * Nome da tela atual. 'home' é o fallback padrão (ver SCREEN_COMPONENTS em
 * screen-registry.ts) — qualquer outro valor deve ter uma entrada correspondente
 * nesse registro para ser renderizado dinamicamente.
 */
export type AppScreen = string;

/** Tela de escolha de tema de cada modo (destino do "Jogar Novamente"). */
const THEME_SCREEN_BY_MODE: Record<GameMode, AppScreen> = {
  [GameMode.ModoSolo]: 'theme',
  [GameMode.DailyDash]: 'daily-theme',
};

@Injectable({ providedIn: 'root' })
export class ScreenNavigationService {
  private readonly currentScreen = signal<AppScreen>('home');
  private readonly selectedTheme = signal<Theme | null>(null);
  readonly screen = this.currentScreen.asReadonly();
  readonly theme = this.selectedTheme.asReadonly();

  goToHome(): void {
    this.navigate('home');
  }

  goToTheme(): void {
    this.navigate('theme');
  }

  goToThemeSelection(mode: GameMode): void {
    this.navigate(THEME_SCREEN_BY_MODE[mode]);
  }

  goToDailyTheme(): void {
    this.navigate('daily-theme');
  }

  goToDailyCalendar(): void {
    this.navigate('daily-calendar');
  }

  goToGame(theme: Theme): void {
    this.selectedTheme.set(theme);
    this.navigate('game');
  }

  navigate(screen: AppScreen): void {
    if (typeof document.startViewTransition !== 'function') {
      this.currentScreen.set(screen);
      return;
    }
    document.startViewTransition(() => this.currentScreen.set(screen));
  }
}
